import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('poster/list', { params });
  },
  async add(params: any) {
    return axios.post('poster/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('poster/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('poster/detail', { params });
  },
  async delete(params: any) {
    return axios.post('poster/delete', qs.stringify(params));
  },
  async logs(params: any) {
    return axios.get('poster/logs', { params });
  },
  async stadiums(params: any) {
    return axios.get('poster/stadiums', { params });
  },
  async preview(params: any) {
    return axios.post('poster/preview', qs.stringify(params));
  },
};
